import { render, staticRenderFns } from "./MetasEvento.vue?vue&type=template&id=4cda6c07"
import script from "./MetasEvento.vue?vue&type=script&lang=js"
export * from "./MetasEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports